/** Коды способов оплаты ЮKassa (payment_method_data.type). */
export type YooKassaPaymentMethod =
  | 'sberbank'
  | 'bank_card'
  | 'yoo_money'
  | 'tinkoff_bank'
  | 'alfa_pay'
  | 'sbp';

export type YooKassaPaymentMethodOption = {
  type: YooKassaPaymentMethod;
  name: string;
  meta: string;
  logoClass: string;
  logoText: string;
};

export const YOOKASSA_PREFERRED_METHOD_KEY = 'yookassa_preferred_payment_method';

export const YOOKASSA_PAYMENT_METHODS: YooKassaPaymentMethodOption[] = [
  {
    type: 'sberbank',
    name: 'SberPay',
    meta: 'Быстрая оплата для клиентов Сбера',
    logoClass: 'balance-payment__logo--sber',
    logoText: 'S',
  },
  {
    type: 'bank_card',
    name: 'Банковская карта',
    meta: 'Сохранённая или новая',
    logoClass: 'balance-payment__logo--card',
    logoText: '₽',
  },
  {
    type: 'yoo_money',
    name: 'ЮMoney',
    meta: 'Кошелёк или привязанная карта',
    logoClass: 'balance-payment__logo--yumoney',
    logoText: 'Ю',
  },
  {
    type: 'tinkoff_bank',
    name: 'T-Pay',
    meta: 'Приложение Т-Банк',
    logoClass: 'balance-payment__logo--tpay',
    logoText: 'T',
  },
  {
    type: 'alfa_pay',
    name: 'Alfa Pay',
    meta: 'Для клиентов Альфа-Банка',
    logoClass: 'balance-payment__logo--alfa',
    logoText: 'A',
  },
  {
    type: 'sbp',
    name: 'СБП',
    meta: 'Приложение вашего банка',
    logoClass: 'balance-payment__logo--sbp',
    logoText: 'СБП',
  },
];

const ALLOWED = new Set<string>(YOOKASSA_PAYMENT_METHODS.map((m) => m.type));

/** null = общая страница ЮKassa со всеми способами. */
export function readPreferredPaymentMethod(): YooKassaPaymentMethod | null {
  try {
    const raw = localStorage.getItem(YOOKASSA_PREFERRED_METHOD_KEY);
    if (raw === null || raw === '' || raw === 'yookassa') return null;
    if (ALLOWED.has(raw)) return raw as YooKassaPaymentMethod;
  } catch {
    // ignore
  }
  return null;
}

export function writePreferredPaymentMethod(method: YooKassaPaymentMethod | null): void {
  try {
    localStorage.setItem(YOOKASSA_PREFERRED_METHOD_KEY, method ?? 'yookassa');
  } catch {
    // ignore
  }
}

export function yooKassaMethodLabel(type: YooKassaPaymentMethod | null | undefined): string {
  if (!type) return 'ЮKassa';
  return YOOKASSA_PAYMENT_METHODS.find((m) => m.type === type)?.name ?? 'ЮKassa';
}

export function yooKassaMethodOption(
  type: YooKassaPaymentMethod | null
): Pick<YooKassaPaymentMethodOption, 'name' | 'meta' | 'logoClass' | 'logoText'> {
  if (!type) {
    return {
      name: 'ЮKassa',
      meta: 'Все способы на странице оплаты',
      logoClass: '',
      logoText: 'ЮK',
    };
  }
  const found = YOOKASSA_PAYMENT_METHODS.find((m) => m.type === type);
  return (
    found ?? {
      name: 'ЮKassa',
      meta: 'Все способы на странице оплаты',
      logoClass: '',
      logoText: 'ЮK',
    }
  );
}
